import { render, staticRenderFns } from "./ExtrinsicLink.vue?vue&type=template&id=e004ab2a&"
import script from "./ExtrinsicLink.vue?vue&type=script&lang=js&"
export * from "./ExtrinsicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports